export default __webpack_public_path__ + "static/media/Exhibit Highlights.d0020d08.svg";